import { useEffect, useState } from 'react'
import { Grid } from 'antd'

const { useBreakpoint } = Grid
const MOBILE_MEDIA_QUERY =
  '(max-width: 768px), (max-device-width: 768px), ((hover: none) and (pointer: coarse) and (max-width: 1024px))'

export const useIsMobile = () => {
  const screens = useBreakpoint()
  const [matchesMobileMedia, setMatchesMobileMedia] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return false
    }
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return
    }

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY)
    const updateMatches = () => setMatchesMobileMedia(mediaQuery.matches)

    updateMatches()
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateMatches)
      return () => mediaQuery.removeEventListener('change', updateMatches)
    }

    mediaQuery.addListener(updateMatches)
    return () => mediaQuery.removeListener(updateMatches)
  }, [])

  return matchesMobileMedia || !screens.md
}

export default useIsMobile
